import { render } from "./ColorMatch.vue?vue&type=template&id=75855381&scoped=true"
import script from "./ColorMatch.vue?vue&type=script&lang=js"
export * from "./ColorMatch.vue?vue&type=script&lang=js"

import "./ColorMatch.vue?vue&type=style&index=0&id=75855381&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75855381"]])

export default __exports__